function openConsentDialog(ref) {
  const instance = ref.getWrappedInstance();

  return instance.dialog.openDialog();
}

export default openConsentDialog;
